module.exports = __webpack_public_path__ + "img/explore.1b2d906e.svg";